import { Button } from "@svea/design-system-components-react";
import { type Dispatch, type ReactNode, type SetStateAction, useRef, useState } from "react";
import { Popover } from "react-aria-components";
import { tw } from "../../styling";

const tooltipClasses = tw`rounded-md border border-black p-4 transition-opacity duration-300 data-entering:opacity-0 data-exiting:opacity-0`;

export const AriaPopover = ({
	content,
	buttonText = "Läs mer",
	iconStart = "informationCircle",
	variant = "default",
	position = "bottom",
	fullWidth,
	offset = 32,
	className,
}: {
	content: ({ setIsOpen }: { setIsOpen: Dispatch<SetStateAction<boolean>> }) => ReactNode;
	buttonText?: string;
	iconStart?: "calendar" | "horizontalSlider" | "informationCircle";
	variant?: "info" | "default";
	position?: "bottom" | "bottom start";
	fullWidth?: boolean;
	offset?: number;
	className?: string;
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const triggerRef = useRef<HTMLDivElement>(null);

	return (
		<>
			<span ref={triggerRef} className={tw(fullWidth && "w-full")}>
				{variant === "info" ? (
					<Button
						variant="icon"
						icon={iconStart}
						aria-label={buttonText}
						onPress={() => setIsOpen(!isOpen)}
					/>
				) : (
					<Button
						type="button"
						onPress={() => setIsOpen(true)}
						variant="secondary"
						iconStart={iconStart}
						width={fullWidth ? "full" : "auto"}
					>
						{buttonText}
					</Button>
				)}
			</span>
			<Popover
				triggerRef={triggerRef}
				onOpenChange={setIsOpen}
				isOpen={isOpen}
				offset={offset}
				placement={position}
				className={tw(
					tooltipClasses,
					className,
					variant === "info"
						? "bg-background-tertiary tablet:w-[325px]"
						: "shadow-bistron bg-white",
				)}
			>
				{content({ setIsOpen })}
			</Popover>
		</>
	);
};
